export const camalize = (str) =>
  str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())

export const kebabify = (str) =>
  str
    .split(" ")
    .map((s) => s.toLowerCase())
    .join("-")

export const rnd = (len) =>
  Math.random()
    .toString(36)
    .substring(2, 2 + len)

export const bin = () => Math.random() > 0.5

export const zip = (a, b) => a.map((k, i) => [k, b[i]])

export const shuffle = (xs) =>
  xs
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)

export const checkAlphanum = (
  txt,
  { allowSpaces = false, allowHyphen = false } = {}
) => {
  let r =
    allowSpaces && allowHyphen
      ? /^[a-zA-Z0-9\s-]+$/
      : !allowSpaces && allowHyphen
      ? /^[a-zA-Z0-9-]+$/
      : allowSpaces && !allowHyphen
      ? /^[a-zA-Z0-9\s]+$/
      : /* (!allowHyphen && !allowSpaces) */ /^[a-zA-Z0-9]+$/
  return r.test(txt)
}

export const asciify = (str) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]/g, "-")
